import { Badge, Flex, Icon } from '@chakra-ui/react';
import { BsFillArrowDownCircleFill, BsFillArrowUpCircleFill, BsDashCircleFill } from 'react-icons/bs';
import { getPercentageDifference } from 'utils/number';
import { toPercentageFormat } from 'utils/format';

export interface GrowthBadgeProps {
  starting?: number;
  ending?: number;
  percentage?: number;
  showRawDelta?: boolean;
  inverse?: boolean;
  onClick?: () => void;
}

export default function GrowthBadge({ starting, ending, percentage, showRawDelta, inverse = false, onClick }: GrowthBadgeProps) {
  let percentageDifference;

  if (percentage !== undefined) {
    percentageDifference = percentage;
  } else if (starting !== undefined && ending !== undefined) {
    percentageDifference = getPercentageDifference(starting, ending);
  } else {
    percentageDifference = 0;
  }

  const roundedDifference = Math.round(percentageDifference);
  let colorScheme, icon, title;

  if (roundedDifference > 0) {
    colorScheme = inverse ? 'red' : 'green';
    icon = BsFillArrowUpCircleFill;
  } else if (roundedDifference < 0) {
    colorScheme = inverse ? 'green' : 'red';
    icon = BsFillArrowDownCircleFill;
  } else {
    colorScheme = 'gray';
    icon = BsDashCircleFill;
  }

  if (showRawDelta && starting !== undefined && ending !== undefined) {
    const rawDelta = ending - starting;
    title = rawDelta > 0 ? `+${rawDelta.toFixed(2)}` : rawDelta.toFixed(2);
  } else {
    const formattedPercentage = toPercentageFormat(percentageDifference);
    title = roundedDifference > 0 ? `+${formattedPercentage}` : formattedPercentage;
  }

  return (
    <Badge padding="2px 4px" borderRadius={4} width={'fit-content'} height={'fit-content'} colorScheme={colorScheme} onClick={onClick} cursor={onClick ? 'pointer' : ''}>
      <Flex direction="row" gap={1} alignItems="center">
        <Icon as={icon} w={3} h={3} />
        {title}
      </Flex>
    </Badge>
  );
};
